import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { CheckToken } from "../../login/AccessToken";
import { Grid, Autocomplete, TextField } from "@mui/material";
import {
  CustomStyledButtonSolid,
  StyledTextFieldBootstrap,
  theme,
} from "../../doctor-console/StyledComponents";
import { toast } from "react-toastify";
import ConsentModal from "../../../components/ConsentModal";
import axios from "axios";
import ConsentHistory from "../../doctor-console/Modals/ConsentHistory";
import { ThemeProvider } from "@mui/material/styles";

function Consent() {
  const history = useHistory();
  let subscriptionType = sessionStorage.getItem("subscriptionType");
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [accessToken, setAccessToken] = useState("");
  const [consentCreationModalOpen, setConsentCreationModalOpen] =
    useState(false);
  const [consentHistoryModalOpen, setConsentHistoryModalOpen] = useState(false);
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const [patientList, setPatientList] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  const REACT_APP_IDENTIFIER_TYPE = process.env.REACT_APP_IDENTIFIER_TYPE;
  const REACT_APP_IDENTIFIER_VALUE = process.env.REACT_APP_IDENTIFIER_VALUE;
  const REACT_APP_IDENTIFIER_SYSTEM = process.env.REACT_APP_IDENTIFIER_SYSTEM;
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const REACT_APP_HIU = process.env.REACT_APP_HIU;
  useEffect(() => {
    console.log("HRP", isHRPSubscriptionType());
    if (authToken !== "" && isHRPSubscriptionType()) {
      axios
        .get(
          `${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`,
          {
            headers: headers,
          }
        )
        .then((res) => {
          setPatientList(res.data?.data);
        });
    }
  }, [authToken, subscriptionType]);
  const navigate = (e) => {
    history.push(`/${e.target.id}`);
  };
  const handleConsentHistoryModalOpen = () => {
    if (
      (isHRPSubscriptionType() && selectedPatient) ||
      !isHRPSubscriptionType()
    ) {
      setConsentHistoryModalOpen(true);
      setError(null);
    } else {
      setError("Please select Patient");
    }
  };
  const handleConsentHistoryModalClose = () => {
    setConsentHistoryModalOpen(false);
  };
  const handleConsentCreationModalOpen = () => {
    if (
      (isHRPSubscriptionType() && selectedPatient) ||
      !isHRPSubscriptionType()
    ) {
      setConsentCreationModalOpen(true);
      setError(null);
    } else {
      setError("Please select Patient");
    }
  };
  const handleConsentCreationModalClose = () => {
    setConsentCreationModalOpen(false);
  };
  const getPatientDataConsent = (abha_id, data) => {
    console.log("Get Patient Data", abha_id);
    console.log(data.purpose);

    if (Token()) {
      if (data.length > 0) {
        axios
          .post(
            `${REACT_APP_BACKEND_ROUTE_URL}gateway/create_consent_request_init/`,
            {
              consent: {
                purpose: {
                  text: "string",
                  code: data[0].purpose,
                },
                patient: {
                  id: abha_id,
                },
                hiu: {
                  id: REACT_APP_HIU,
                },
                requester: {
                  name: sessionStorage.getItem("facility_name"),
                  // identifier: {
                  //   type: REACT_APP_IDENTIFIER_TYPE,
                  //   value: REACT_APP_IDENTIFIER_VALUE,
                  //   system: REACT_APP_IDENTIFIER_SYSTEM,
                  // },
                },
                hiTypes: data[0].infoTypes.map((infoType) =>
                  infoType.replace(" ", "")
                ),
                permission: {
                  accessMode: "VIEW",
                  dateRange: {
                    from: data[0].from,
                    to: data[0].to,
                  },
                  dataEraseAt: data[0].expiry,
                  frequency: {
                    unit: "HOUR",
                    value: 1,
                    repeats: 0,
                  },
                },
              },
            },
            {
              headers: headers,
            }
          )
          .then(async (response) => {
            if (response.data.request_id) {
              var c = 0;
              console.log("GOT THIS RESPONSE");
              console.log("GOT THIS RESPONSE", response.data);
              console.log("GOT THIS RESPONSE MESSAGE", response.data.message);
              // setFinalStatus(
              //   "Health Information Consent Created. Awaiting Patient Approval ..."
              // );
              toast.success(
                "Consent request submitted. Please wait a moment to view the consent history."
              );
            } else {
              toast.error(response.data.message);
            }
          })
          .catch((error) => {
            console.log("FETCH FAILED");
            console.log(error);
            toast.error(error);
          });
      }
    }
  };
  const isHRPSubscriptionType = () => {
    console.log("SubscriptionType", subscriptionType);
    if (
      subscriptionType ==
        "Health Repository Provider (HRP) Service - HIU/HIP" ||
      subscriptionType == "Health Repository Provider (HRP) Service - HIU" ||
      subscriptionType == "Health Repository Provider (HRP) Service - HIU/HIP"
    ) {
      return true;
    }
    return false;
  };
  const validateErrors = () => {};
  return (
    <ThemeProvider theme={theme}>
      <h1 style={{ textAlign: "center" }}> Longitudinal Data Access</h1>
      <Grid
        container
        spacing={3}
        sx={{
          p: { xs: 1, sm: 2, md: 3 }, // Responsive padding left/right
          width: { xs: "90%", sm: "80%", md: "60%" },
          margin: "20px auto",
          justifyContent: "center", // Center the grid container
          boxShadow: 3, // Add a shadow for card styling
          borderRadius: 2, // Rounded corners
        }}
      >
        {isHRPSubscriptionType() && (
          <Grid item xs={12}>
            <Autocomplete
              options={patientList}
              getOptionLabel={(option) => `${option.name} ${option.patient_id}`}
              value={selectedPatient}
              onChange={(_, value) => {
                setError(null);
                setSelectedPatient(value);
              }}
              renderInput={(params) => (
                <StyledTextFieldBootstrap
                  {...params}
                  label="Select Patient"
                  error={!!error} // Highlight field in red if there's an error
                  helperText={error} // Show error message
                  variant="outlined"
                  fullWidth
                />
              )}
              isOptionEqualToValue={(option, value) =>
                option.patient_id === value.patient_id
              }
            />
          </Grid>
        )}
        <Grid item xs={12} sm={6}>
          <CustomStyledButtonSolid
            fullWidth
            sx={{ width: "100%" }}
            onClick={handleConsentCreationModalOpen}
          >
            Get Patient Data
          </CustomStyledButtonSolid>
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomStyledButtonSolid
            fullWidth
            sx={{ width: "100%" }}
            onClick={handleConsentHistoryModalOpen}
          >
            Consent History
          </CustomStyledButtonSolid>
        </Grid>
      </Grid>
      <ConsentModal
        isOpen={consentCreationModalOpen}
        getPatientDataConsent={getPatientDataConsent}
        patientData={selectedPatient}
        onSubmitClose={handleConsentCreationModalClose}
        onRequestClose={handleConsentCreationModalClose}
      />
      <ConsentHistory
        open={consentHistoryModalOpen}
        handleClose={handleConsentHistoryModalClose}
        patientData={selectedPatient}
      />
    </ThemeProvider>
  );
}

export default Consent;
